import { useState, useEffect } from "react";

interface DeviceInfo {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isWebBrowser: boolean;
  isStandalone: boolean;
  platform: string;
  userAgent: string;
}

export const useDeviceDetection = (): DeviceInfo => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    isWebBrowser: true,
    isStandalone: false,
    platform: "",
    userAgent: "",
  });

  useEffect(() => {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;

    // Detectar se está rodando como PWA/standalone
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator as any).standalone === true ||
      document.referrer.includes("android-app://");

    // Detectar dispositivo móvel
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      );

    // Detectar tablet
    const isTablet =
      /iPad|Android(?!.*Mobile)/i.test(userAgent) ||
      (userAgent.includes("Mac") && "ontouchend" in document);

    // Detectar desktop
    const isDesktop = !isMobile && !isTablet;

    // Detectar se está no navegador web (não é app nativo)
    const isWebBrowser =
      (!isStandalone &&
        !userAgent.includes("wv") && // não é WebView
        !userAgent.includes("Version/")) || // não é app nativo do Android
      userAgent.includes("Chrome") ||
      userAgent.includes("Firefox") ||
      userAgent.includes("Safari");

    setDeviceInfo({
      isMobile,
      isTablet,
      isDesktop,
      isWebBrowser,
      isStandalone,
      platform,
      userAgent,
    });
  }, []);

  return deviceInfo;
};
